module.exports = __webpack_public_path__ + "google-map.min.js";